var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.checkDate(_vm.$store.state.privateEvent.unsaved.events[this.index]))?_c('span',{staticClass:"error"},[_c('icon',{attrs:{"id":"square-alert"}}),_vm._v(" Bitte Termindatum überprüfen ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }